import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowUpFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowUpFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m21 9.885-9-6.3-9 6.3v3.66l7.5-5.25v12.12h3V8.295l7.5 5.25v-3.66Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowUpFilled;